import React, { useEffect, useState } from "react";
import {
  BedIcon,
  ChevronRightIcon,
  DrinkGlassIcon,
  FamilyIcon,
  GlassIcon,
  ParkIcon,
  ServiceIcon,
  WiFiIcon,
} from "../../../../helper/HwIcon";

export const HotelPopularFacilities = ({ scrollToDiv , categories, facilities }) => {
  const [data,setData] = useState([])

  const getCategoryItem = (categoryName) => {
    if (!categoryName) return { icon: <ServiceIcon />, label: "" };

    if (categoryName?.includes("Rest")) {
      return { icon: <GlassIcon />, label: categoryName };
    } else if (categoryName?.includes("Internet")) {
      return { icon: <WiFiIcon />, label: categoryName };
    } else if (categoryName?.includes("Park")) {
      return { icon: <ParkIcon />, label: categoryName };
    } else if (categoryName?.includes("Room")) {
      return { icon: <BedIcon />, label: categoryName };
    } else if (categoryName?.includes("Break")) {
      return { icon: <DrinkGlassIcon />, label: categoryName };
    }

    return { icon: <ServiceIcon />, label: categoryName }
  }

  useEffect(()=>{
    if(Array.isArray(categories) && categories.length){
      setData(categories.map(c=> getCategoryItem(c?.name)))
    }
  },[])

  const getTotalFacilitiesCount = () => {
    if (facilities && Array.isArray(facilities)) {
      return facilities.reduce((total, category) => {
        return total + (category?.amenities?.length || 0);
      }, 0);
    }
    if (categories && categories.length > 0) {
      return categories.length * 15;
    }
    return 80;
  };

  const getShownFacilitiesCount = () => {
    if (data?.length > 0) {
      return Math.min(data.length, 6);
    }
    return 6;
  };

  const shouldShowViewMore = () => {
    const totalCount = getTotalFacilitiesCount();
    const shownCount = getShownFacilitiesCount();
    const additionalCount = totalCount - shownCount;
    return additionalCount >= 3;
  };

  const totalFacilitiesCount = getTotalFacilitiesCount() || 80;
  const showViewMore = shouldShowViewMore();


  return (
    <div id="hotel_popular" className="hw-hotel--singleListSection">
      <h2 className="h4 mb-2">Popular Facilities</h2>
      <div className="hw-section--box">
        <ul className="box-ul">
          {
            data?.length > 0 ? data.slice(0,6).map((d)=>{
              return (
                <li className="d-flex hw-gapy4 align-items-center hw-fontWeight--500 hw-icon--div">
                  {d?.icon}
                  {d?.label}
                </li>
              )
            }) : <>
              <li className="d-flex hw-gapy4 align-items-center hw-fontWeight--500 hw-icon--div">
                <GlassIcon />
                Breakfast Available
              </li>
              <li className="d-flex hw-gapy4 align-items-center hw-fontWeight--500 hw-icon--div">
                <BedIcon />
                Double Bed
              </li>
              <li className="d-flex hw-gapy4 align-items-center hw-fontWeight--500 hw-icon--div">
                <WiFiIcon />
                Free Internet Access
              </li>
              <li className="d-flex hw-gapy4 align-items-center hw-fontWeight--500 hw-icon--div">
                <FamilyIcon />
                Family-Friendly
              </li>
              <li className="d-flex hw-gapy4 align-items-center hw-fontWeight--500 hw-icon--div">
                <ServiceIcon />
                24/7 Service Available
              </li>
              <li className="d-flex hw-gapy4 align-items-center hw-fontWeight--500 hw-icon--div">
                <ParkIcon />
                Parking Included
              </li>
            </>
          }
        </ul>
        {showViewMore && (
          <div
            className="hw-bprimary--link mt-10"
            onClick={() => {
              scrollToDiv("hotel_facilities");
            }}
          >
            View {totalFacilitiesCount}+ More
            <ChevronRightIcon />
          </div>
        )}
      </div>
    </div>
  );
};
